import { render, staticRenderFns } from "./comp_MercadoPago-Payment-CheckoutOptions.vue?vue&type=template&id=631c5771&"
import script from "./comp_MercadoPago-Payment-CheckoutOptions.vue?vue&type=script&lang=js&"
export * from "./comp_MercadoPago-Payment-CheckoutOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports